import React, { useContext, useEffect, useState } from 'react';
import SearchTermInput from '../search/SearchTermInput';
import { useTranslations } from 'next-intl';
import StatBankFilterOptions from './StatBankFilterOptions';
import { useRouter } from 'next/router';
import { assignValuesFromRouteQuery, pushValuesToRouteQuery, replaceValuesOfRouteQuery } from '@/utils';
import {
  AppInsightsContext,
  TrackEventKey,
  TrackEventName,
  TrackEventType,
} from '../azureAppInsights/AzureAppInsightsContext';
import { MetadataContext, UserContext } from '../ContextProviders';

export type StatBankFilterType = {
  id: string;
  key: string;
  name: string;
  disabled: boolean;
  options: {
    group: string;
    id: string;
    key: string;
    name: string;
    parentName: string;
  }[];
};

type StatBankFiltersProps = {
  filters: StatBankFilterType[];
  result: any;
};

const StatBankFilters = ({ filters, result }: StatBankFiltersProps) => {
  const [searchTerm, setSearchTerm] = useState('');
  const t = useTranslations();
  const router = useRouter();
  const appInsights = useContext(AppInsightsContext);
  const { pageId } = useContext(MetadataContext);
  const user = useContext(UserContext);

  useEffect(() => {
    const searchTermFromQuery = { searchTerm: '' };
    assignValuesFromRouteQuery(router, searchTermFromQuery);
    setSearchTerm(searchTermFromQuery.searchTerm || '');
  }, [router.query, router]);

  const onSubmit = () => {
    if (router.query.searchTerm !== searchTerm) {
      appInsights.trackCustomEvent(
        TrackEventName.STAT_BANK,
        TrackEventKey.SEARCH_STAT_BANK,
        TrackEventType.NONE,
        user,
        {
          pageId,
          pagePath: router.asPath,
          searchTerm,
        },
      );

      pushValuesToRouteQuery(router, { searchTerm, page: null });
    }
  };

  const onClear = () => {
    replaceValuesOfRouteQuery(router, {});
  };

  return (
    <div id="stat-bank-filters">
      <div className="bg-gray-2">
        <div className="xxl:px-140 px-5 py-5 md:px-5 xl:px-46">
          <SearchTermInput
            placeholder={t('search.$searchbykeyword')}
            autofocus={false}
            value={searchTerm}
            onChange={(value) => setSearchTerm(value)}
            onSubmit={onSubmit}
            onClear={onClear}
          />
        </div>
      </div>
      <hr className="h-px border-0 bg-black/10" />
      <div className="container hidden py-6 md:block md:px-2">
        <StatBankFilterOptions availableFilters={filters} facets={result.facets} />
      </div>
    </div>
  );
};

export default StatBankFilters;
